import axios from 'axios';
import ITgAd from './ITgAd';

export default class TgAdManager {
    private tgId: string;
    private size: string;
    private ads: ITgAd[] = [];

    constructor(tgId: string, size: string) {
        this.tgId = tgId;
        this.size = size;
    }

    public getAd = (): Promise<ITgAd> => {
        return new Promise<ITgAd>(async (resolve, reject) => {
            if (this.ads.length === 0) {
                try {
                    await this.loadAds();
                } catch {
                    reject();
                }
            }

            if (this.ads.length > 0) {
                resolve(this.ads[Math.round(Math.random() * (this.ads.length - 1))]);
            } else {
                reject();
            }
        });
    }

    private loadAds = (): Promise<TgAdManager>  => {
        return new Promise<TgAdManager>((resolve, reject) => {
            axios.get(
                `https://tinygoodies.com/ads/ads-${this.size}.json`,
            )
            .then((value) => {
                if (value.status === 200) {
                    const ads = value.data as ITgAd[];
                    this.ads = ads.filter((el) => el.name.indexOf(this.tgId) !== 0);
                    resolve(this);
                } else {
                    reject();
                }
            })
            .catch(() => reject());
        });
    }
}
